import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Nav from "components/layout/Nav";
import { DataTable } from "components/shared/table";
import { TrashMenubar } from "components/layout/MenuBar";
import { IoArrowBack } from "react-icons/io5";

// ✅ Import all slices for segments
import { fetchTrashedTrek, restoreTrek, permanentDeleteTrek } from "../../Slices/trek.slice";
import { fetchTrashedLocations, restoreLocation, permanentDeleteLocation } from "../../Slices/travel.slice";

const TrashBox = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");


  // ✅ Fetch all trashed data from all segments
  const { trashedTrek } = useSelector((state) => state.trek);
  const { trashedLocations } = useSelector((state) => state.travel);

  useEffect(() => {
    dispatch(fetchTrashedTrek());
    dispatch(fetchTrashedLocations());
  }, [dispatch]);

  const allTrashedLocations = [
    ...(trashedTrek || []).map((item) => ({ ...item, segment: "trek" })),
    ...(trashedLocations || []).map((item) => ({ ...item, segment: "travel" })),
  ];


  const filteredLocations = allTrashedLocations.filter((loc) =>
    [loc.locationName, loc.category, loc.type]
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );


  const handleRestore = (id, segment) => {
    const restoreAction = segment === "trek" ? restoreTrek : restoreLocation;
    dispatch(restoreAction(id)).then((result) => {
      if (result.type.endsWith("/fulfilled")) {
        const restoredItem = result.payload.restoredLocation || result.payload;
        const categoryPath = restoredItem?.category?.toLowerCase().replace(/\s+/g, '-') || segment;
        navigate(`/cms/${categoryPath}/all-locations`);
      }
    });
  };

  const handlePermanentDelete = (id, segment) => {
    if (window.confirm("Are you sure you want to permanently delete this item?")) {
      const deleteAction = segment === "trek" ? permanentDeleteTrek : permanentDeleteLocation;
      dispatch(deleteAction(id)).then((result) => {
        if (result.type.endsWith("/fulfilled")) {
          dispatch(fetchTrashedTrek());
          dispatch(fetchTrashedLocations());
        }
      });
    }
  };
  



  const goToCMSHome = () => navigate("/cms");

  return (
    <>
      <Nav />
      <div className="row">
        <TrashMenubar setSearchTerm={setSearchTerm} />
        <main style={{ width: "100vw", backgroundColor: "#D0D5DD" }}>
          <div className="row justify-content-between">
            <h3>🗑️ All Segments - Trash Box</h3>
            <button className="btn" onClick={goToCMSHome}>
              <IoArrowBack /> Go to CMS Home
            </button>
          </div>
          {allTrashedLocations.length === 0 ? (
            <p>No trashed locations available.</p>
          ) : (
            <DataTable
              locations={filteredLocations}
              editClick={() => { }}
              deleteConfirmation={(id) => {
                const location = allTrashedLocations.find(loc => loc._id === id);
                handlePermanentDelete(id, location?.segment);
              }}
              restoreClick={(id, segment) => handleRestore(id, segment)}
              showCategoery={true}
              showRestore={true}
            />

          )}
        </main>
      </div>
    </>
  );
};

export default TrashBox;
